import {toEmojiHtml} from "@/app/utils/Format";

export default function(text) {
    return new Handlebars.SafeString(toEmojiHtml(text));
}